import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "👁️", key: "theEyes" },
  { emoji: "😍", key: "theExpression" },
  { emoji: "🎭", key: "theScene" },
  { emoji: "🖌️", key: "theComposition" },
]

export default function PetsMustTrackPage() {
  return <RadioCardListPage translationKey="petsMustTrack" options={OPTIONS} />
}
